module.exports = __webpack_public_path__ + "static/media/money.a434359c.png";